import { useMatches } from 'react-router-dom';

export function useIsSettings() {
  const matches = useMatches();
  const lastMatch = matches[matches.length - 1];
  const isSettingsPage = lastMatch?.id === 'settings' || lastMatch?.id === 'settings_audit_logs';
  const isWorkspaceSettingsPage = lastMatch?.id?.startsWith('workspace_settings') === true;
  const isAnySettingsPage = isSettingsPage || isWorkspaceSettingsPage;

  return {
    isSettingsPage,
    isWorkspaceSettingsPage,
    isAnySettingsPage,
  };
}
